// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__aX4Mv","indicator":"Checkbox_indicator__LeSrt","label":"Checkbox_label__FL7bn"};